export default (props, vars) => props?.['name'] === 'military-tech';
